var exports = {
  "kL": "x93eb46d8--d851eb--container",
  "iE": "x93eb46d8--d851eb--wrapper",
  "Qs": "x93eb46d8--d851eb--content",
  "pl": "x93eb46d8--d851eb--content--ectopic",
};

module.exports = exports;
